import { Checkbox, Grid, Typography, Box, Tooltip, makeStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { useHazardMap } from "./HazardMapContext";
import { handleNullValue, round3 } from "../util/tableUtils";
import { lightGrey } from "../util/colors";

const useStyles = makeStyles(() => ({
  hoverGrid: {
    borderRadius: "5px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: lightGrey,
    },
  },
  clickableText: {
    cursor: "pointer",
  },
  checkbox: {
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-checked": {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
}));

type HazardComponentProps = {
  hazardProp: HazardWithData;
};

const HazardComponent = ({ hazardProp: hazard }: HazardComponentProps) => {
  const classes = useStyles();
  const { selectedHazard, onHazardChange } = useHazardMap();

  const onCheckboxChange = (hazard: HazardWithData) => {
    let currSelectedHazard;
    if (hazard.cysId !== selectedHazard?.cysId) {
      currSelectedHazard = hazard;
    }
    onHazardChange(currSelectedHazard as HazardWithData);
  };

  return (
    <Grid container alignItems="center" wrap="nowrap" className={classes.hoverGrid}>
      <Grid item xs={4}>
        <Box display="flex" alignItems="center">
          <Checkbox
            className={classes.checkbox}
            // disableRipple TODO: does not work
            checked={selectedHazard?.cysId === hazard.cysId}
            onChange={() => onCheckboxChange(hazard)}
            value={hazard.label}
            color="primary"
          />

          <Tooltip title={hazard.description || "Risk Exposure"} placement="top-start">
            <InfoOutlinedIcon style={{ height: 15, width: 15, marginRight: 5 }} />
          </Tooltip>
          <Typography
            variant="body2"
            className={classes.clickableText}
            onClick={() => onCheckboxChange(hazard)}
          >
            {hazard.label}
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={1}>
        <Typography variant="body2" align="center">
          {handleNullValue(round3(hazard.value))}
        </Typography>
      </Grid>

      <Grid item xs={3}>
        <Box display="flex" flexDirection="row" width="100%" height={15}>
          {hazard.colorRange.map((color, index) => (
            <Box key={index} flex={1} bgcolor={color} display="flex" justifyContent={"center"}>
              {index === hazard.rating && (
                <Box width={10} height={10} bgcolor="black" borderRadius="50%" border="2px solid white" />
              )}
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid item xs={2}>
        <Typography variant="body2" align="center">
          {handleNullValue(hazard.level)}
        </Typography>
      </Grid>

      <Grid item xs={2}>
        <Typography variant="body2" align="center">{`${handleNullValue(hazard.rating)}/${
          hazard.maxRateAccepted - 1
        }`}</Typography>
      </Grid>
    </Grid>
  );
};

export default HazardComponent;
